// Permanent store QR helpers. The handle comes from stores.qr_handle (e.g. store-42@goerone) and can be changed later.
export const STORE_QR_PATH = "/web/pay"; // customer landing route: /web/pay/:handle

/** Loose format check (the handle can be changed later, so no store-{id} assumption) */
export const isValidHandle = (handle) => /^[A-Za-z0-9._-]{1,80}@[A-Za-z0-9._-]{1,40}$/.test(String(handle || ""));

/** The URL encoded inside the QR. Pasting it in a browser opens the customer pay page; the mobile app can read the same URL later. */
export const buildStoreQrLink = (handle) =>
    `${window.location.origin}${STORE_QR_PATH}/${encodeURIComponent(handle)}`;

/** Render the QR's <svg> to a PNG file download */
export const downloadQrPng = (svgEl, filename) => {
    if (!svgEl) return;
    const xml = new XMLSerializer().serializeToString(svgEl);
    const img = new Image();
    img.onload = () => {
        const size = 1024;
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, size, size);
        ctx.drawImage(img, 0, 0, size, size);
        const a = document.createElement("a");
        a.href = canvas.toDataURL("image/png");
        a.download = filename;
        a.click();
    };
    img.src = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(xml)))}`;
};